var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.cartItem.quantity)+"x "+_vm._s(_vm.product.name)+" "),(_vm.product.variant)?[_vm._v("• "+_vm._s(_vm.product.variant.name))]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }